import { render, staticRenderFns } from "./HiboLoader.vue?vue&type=template&id=3b5fc76a&scoped=true&"
import script from "./HiboLoader.vue?vue&type=script&lang=ts&"
export * from "./HiboLoader.vue?vue&type=script&lang=ts&"
import style0 from "./HiboLoader.vue?vue&type=style&index=0&id=3b5fc76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5fc76a",
  null
  
)

export default component.exports